// Generated static UI catalog. User-created content is intentionally not included.
module.exports = {
  "Build a workflow, tag it by purpose, and filter the library by the tags that matter most.": "Byg en workflow, tag den efter form\u00e5l, og filtrer biblioteket efter de tags, der betyder mest.",
  "Build Agentic woirkflow with Planner": "Byg Agentic woirkflow med Planner",
  "Build Workflow": "Byg workflow",
  "Build your workflow": "Byg din workflow",
  "Building node": "Bygningsknudepunkt",
  "Building...": "Bygning...",
  "Burnt orange": "Br\u00e6ndt orange",
  "Cache in": "Cache ind",
  "Cache out": "Cache ud",
  "Cache-l\u00e6sning": "Cache-l\u00e6sning",
  "Cache-skrivning": "Cache-skrivning",
  "Call the public run endpoint with this code in __showeventstream and the canvas will follow that execution live.": "Kald det offentlige k\u00f8rselsslutpunkt med denne kode i __showeventstream, og l\u00e6rredet vil f\u00f8lge den eksekvering live.",
  "can now list and run your Browser Action workflows. You can close this tab and reopen the extension.": "kan nu liste og k\u00f8re dine Browser Action-workflows. Du kan lukke denne fane og gen\u00e5bne udvidelsen.",
  "can now run your Browser Action workflows. Reopen the extension popup to continue.": "kan nu k\u00f8re dine Browser Action-workflows. \u00c5bn popup-udvidelsen igen for at forts\u00e6tte.",
  "Cancel": "Annuller",
  "Cancel in-progress Ask?": "Annuller igangv\u00e6rende Sp\u00f8rg?",
  "Cannot convert to code": "Kan ikke konvertere til kode",
  "Capture failed": "Optagelse mislykkedes",
  "Capture full page as separate screenshots": "Tag hele siden som separate sk\u00e6rmbilleder",
  "Captured a screenshot of the workflow": "Tog et sk\u00e6rmbillede af workflowet",
  "Capturing...": "Optager...",
  "Category": "Kategori",
  "Change": "Skift",
  "Change group color": "Skift gruppefarve",
  "Change image": "Skift billede",
  "Change password": "Skift adgangskode",
  "Changes History": "\u00c6ndringshistorik",
  "Changes:": "\u00c6ndringer:",
  "Chat failed": "Chat mislykkedes",
  "Check Silent Error": "Tjek Silent Error",
  "Check text in:": "Tjek tekst ind:",
  "Checking...": "Tjekker...",
  "Choose the permissions this connection can use.": "V\u00e6lg de tilladelser, denne forbindelse kan bruge.",
  "Choose value": "V\u00e6lg v\u00e6rdi",
  "Chrome device authorization": "Chrome-enhedsgodkendelse",
  "Chrome extension approval requested": "Chrome-udvidelsesgodkendelse anmodet",
  "Chrome extension not connected. Install the Alleflow Browser Run extension and reload this page.": "Chrome-udvidelsen er ikke tilsluttet. Installer Alleflow Browser Run-udvidelsen, og genindl\u00e6s denne side.",
  "Chrome is connected": "Chrome er tilsluttet",
  "Classification Labels": "Klassifikationsetiketter",
  "Classify": "Klassificer",
  "Classify-knuden": "Klassificere-knuden",
  "Clear": "Ryd",
  "Clear all": "Ryd alle",
  "Clear filter": "Ryd filter",
  "Clear search": "Ryd s\u00f8gning",
  "Clear selection": "Ryd markering",
  "Clear steps": "Klare trin",
  "Clear workflow?": "Klar workflow?",
  "Click": "Klik",
  "Click \"Attach crop\" to use this region \u2014 or drag again to redraw.": "Klik p\u00e5 \"Vedh\u00e6ft besk\u00e6ring\" for at bruge dette omr\u00e5de - eller tr\u00e6k igen for at tegne igen.",
  "Click + to add a flow, folder, or UI page.": "Klik p\u00e5 + for at tilf\u00f8je et flow, en mappe eller en UI-side.",
  "Click Advanced": "Klik p\u00e5 Avanceret",
  "Click an element...": "Klik p\u00e5 et element...",
  "click to set": "klik for at indstille",
  "Click, type or read on a real webpage": "Klik, skriv eller l\u00e6s p\u00e5 en rigtig webside",
  "Click:": "Klik:",
  "clickIfText": "klik p\u00e5HvisTekst",
  "clicks it open first": "klikker f\u00f8rst p\u00e5 den",
  "Clicks the target inside the FIRST row whose checked text contains the value (case-insensitive). Fails if no row matches.": "Klikker p\u00e5 m\u00e5let inde i den F\u00d8RSTE r\u00e6kke, hvis afkrydsede tekst indeholder v\u00e6rdien (uafh\u00e6ngig af store og sm\u00e5 bogstaver). Mislykkes, hvis ingen r\u00e6kke matcher.",
  "Close": "Luk",
  "Close (deselect node)": "Luk (frav\u00e6lg knude)",
  "Close (Esc)": "Luk (Esc)",
  "Close menu": "Luk menuen",
  "Close output": "Luk output",
  "Close the browser tab after this node finishes": "Luk browserfanen, n\u00e5r denne knude er f\u00e6rdig",
  "Close the tab when this node finishes": "Luk fanen, n\u00e5r denne knude er f\u00e6rdig",
  "Code": "Kode",
  "Coding": "Kodning",
  "Coding...": "Koder...",
  "Color": "Farve",
  "Comma separated \u2014 e.g. Gmail, Jira, Tavily": "Kommasepareret \u2014 f.eks. Gmail, Jira, Tavily",
  "Computer Use": "Brug af computer",
  "Computer Use Settings": "Indstillinger for computerbrug",
  "Condition": "Tilstand",
  "Conditions": "Forhold",
  "Configure AI Node": "Konfigurer AI knude",
  "Configure AI step": "Konfigurer AI-trin",
  "Configure Classifier": "Konfigurer klassificering",
  "Configure labels for": "Konfigurer etiketter til",
  "Configure with AI": "Konfigurer med AI",
  "Configuring...": "Konfigurerer...",
  "Confirm new password": "Bekr\u00e6ft ny adgangskode",
  "Confirm that this code matches the code requested by your Alleflow extension. Your password is never shared.": "Bekr\u00e6ft, at denne kode matcher den kode, som din Alleflow-udvidelse anmoder om. Din adgangskode deles aldrig.",
  "Connect": "Forbind",
  "Connect a Google account": "Tilslut en Google-konto",
  "Connect account": "Tilslut konto",
  "Connect another": "Tilslut en anden",
  "Connect multiple accounts per provider. In a workflow node\u2019s Settings panel, pick which account that specific node uses \u2014 nodes without a selection fall back to your first connected account.": "Tilslut flere konti pr. udbyder. I en workflow-nodes Indstillinger-panel skal du v\u00e6lge, hvilken konto den specifikke knude bruger - knuder uden et valg falder tilbage til din f\u00f8rste tilsluttede konto.",
  "Connect or manage accounts (Google, Slack, etc.)": "Tilslut eller administrer konti (Google, Slack osv.)",
  "Connect your": "Tilslut din",
  "Connected": "Forbundet",
  "Connected accounts": "Tilknyttede konti",
  "Connected accounts for this node": "Forbundne konti for denne knude",
  "Connecting": "Forbinder",
  "Connecting\u2026": "Opretter forbindelse...",
  "connection failed.": "forbindelse mislykkedes.",
  "Connectors": "Stik",
  "Connectors (comma separated)": "Stik (kommasepareret)",
  "Console.Log": "Konsol.Log",
  "Content type": "Indholdstype",
  "Context to inject into AI instructions": "Kontekst til at injicere i AI-instruktioner",
  "Continue from": "Forts\u00e6t fra",
  "Continue from a previous browser node": "Forts\u00e6t fra en tidligere browserknude",
  "Continue from a previous node": "Forts\u00e6t fra en tidligere knude",
  "Continues from:": "Forts\u00e6tter fra:",
  "Control Browser Action steps in this Chrome device": "Styr browserhandlingstrin i denne Chrome-enhed",
  "Convert to Code": "Konverter til kode",
  "Copied": "Kopieret",
  "Copied!": "Kopieret!",
  "Copilot is still working \u2014 closing will stop the current task.": "Copilot arbejder stadig - lukning stopper den aktuelle opgave.",
  "Copy": "Kopi\u00e9r",
  "Copy code": "Kopi\u00e9r kode",
  "Copy public embed URL for this workflow": "Kopi\u00e9r offentlig indlejrings-URL for denne workflow",
  "Copy public URL": "Kopi\u00e9r offentlig URL",
  "Copy URL": "Kopi\u00e9r URL",
  "Copy value to clipboard": "Kopier v\u00e6rdi til udklipsholder",
  "Copy your API key now. You won't be able to see it again.": "Kopi\u00e9r din API-n\u00f8gle nu. Du vil ikke kunne se det igen.",
  "Could not add you to the waitlist.": "Kunne ikke tilf\u00f8je dig til ventelisten.",
  "Could not approve this device.": "Kunne ikke godkende denne enhed.",
  "Could not delete custom object.": "Kunne ikke slette brugerdefineret objekt.",
  "Could not import workflow.": "Kunne ikke importere workflow.",
  "Could not load connected accounts.": "Kunne ikke indl\u00e6se tilsluttede konti.",
  "Could not load history.": "Historien kunne ikke indl\u00e6ses.",
  "Could not load workflow.": "Kunne ikke indl\u00e6se workflowet.",
  "Could not process the cropped image.": "Kunne ikke behandle det besk\u00e5rne billede.",
  "Could not restore this version.": "Kunne ikke gendanne denne version.",
  "Could not save custom object.": "Kunne ikke gemme brugerdefineret objekt.",
  "Could not save notification settings.": "Kunne ikke gemme indstillingerne for underretninger.",
  "Could not start": "Kunne ikke starte",
  "Could not update password.": "Kunne ikke opdatere adgangskoden.",
  "Couldn\u2019t send \u2014 please try again.": "Kunne ikke sende - pr\u00f8v venligst igen.",
  "Couldn't start the workflow": "Kunne ikke starte workflowet",
  "Cover image URL (optional)": "URL for coverbillede (valgfrit)",
  "Create": "Opret",
  "Create a new key": "Opret en ny n\u00f8gle",
  "Create a workflow": "Opret en workflow",
  "Create account": "Opret konto",
  "Create at least one workflow before designing a UI page.": "Opret mindst \u00e9n workflow, f\u00f8r du designer en UI-side.",
  "Create Jira issues, update Confluence pages, and read tickets from workflow nodes through any of your saved Atlassian accounts.": "Opret Jira-problemer, opdater Confluence-sider, og l\u00e6s billetter fra workflow-knuder gennem enhver af dine gemte Atlassian-konti.",
  "Create live version": "Opret live version",
  "Create node": "Opret knude",
  "Create playbook": "Opret spillebog",
  "Create preset nodes by saving a custom node from the canvas": "Opret forudindstillede knuder ved at gemme en brugerdefineret knude fra l\u00e6rredet",
  "Create workflow": "Opret workflow",
  "Created": "Oprettet",
  "Creates a new empty workflow for the authenticated user.": "Opretter en ny tom workflow for den godkendte bruger.",
  "Creating...": "Opretter...",
  "Creativity Level": "Kreativitetsniveau",
  "creativity=": "kreativitet =",
  "curl -H \"X-API-Key: YOUR_KEY\"": "curl -H \"X-API-Key: YOUR_KEY\"",
  "curl -X POST -H \"X-API-Key: YOUR_KEY\" \\": "curl -X POST -H \"X-API-Key: YOUR_KEY\" \\",
  "cURL Preview": "Forh\u00e5ndsvisning af cURL",
  "Current live version": "Aktuel live version",
  "Current password": "Nuv\u00e6rende adgangskode",
  "Custom (every N minutes)": "Brugerdefineret (hvert N. minut)",
  "Custom node": "Brugerdefineret knude",
  "Cut Data Flow": "Sk\u00e6r dataflow",
  "DA": "DA",
  "Dag": "Dag",
  "Daily": "Dagligt",
  "Dark Mode": "M\u00f8rk tilstand",
  "Data type": "Datatype",
  "Date": "Dato",
  "Default": "Standard",
  "Default (workflow owner\u2019s": "Standard (workflow-ejers",
  "Definer input-parametre som brugere udfylder ved korsel.": "Definer input-parametre som brugere udfylder ved korsel.",
  "Definer labels": "Definer etiketter",
  "Delay before step (ms)": "Forsinkelse f\u00f8r trin (ms)",
  "Delete": "Slet",
  "Delete connector": "Slet stik",
  "Delete failed": "Sletning mislykkedes",
  "Delete failed.": "Sletning mislykkedes.",
  "Delete file": "Slet fil",
  "Delete file?": "Vil du slette filen?",
  "Delete flow": "Slet flow",
  "Delete flow?": "Vil du slette flow?",
  "Delete folder": "Slet mappe",
  "Delete folder?": "Vil du slette mappen?",
  "Delete node": "Slet knude",
  "Delete object": "Slet objekt",
  "Delete param": "Slet param",
  "Delete selected nodes": "Slet valgte knuder",
  "Delete this param": "Slet denne param",
  "Delete UI page": "Slet UI-side",
  "Delete UI page?": "Vil du slette UI-siden?",
  "Delete variable": "Slet variabel",
  "Delete?": "Vil du slette?",
  "Deleted / updated with no body.": "Slettet / opdateret uden br\u00f8dtekst.",
  "Demo": "Demo",
  "Demo video": "Demo video",
  "Demo video kommer snart": "Demo video kommer snart",
  "Dependent": "Afh\u00e6ngig",
  "Dependent duplicate node. Unlock to edit independently.": "Afh\u00e6ngig dublet knude. L\u00e5s op for at redigere uafh\u00e6ngigt.",
  "Describe the exact result to complete in the browser. Use @ for variables.": "Beskriv det n\u00f8jagtige resultat, der skal udfyldes i browseren. Brug @ til variable.",
  "Describe the role \u2014 workflow variables will be sent as context": "Beskriv rollen \u2013 workflowvariabler vil blive sendt som kontekst",
  "Describe what this computer-use step should do...": "Beskriv, hvad dette computerbrugstrin skal g\u00f8re...",
  "Describe what to classify \u2014 AI will generate the labels": "Beskriv, hvad der skal klassificeres - AI vil generere etiketterne",
  "Describe what you want in the chat \u2014 the planner will probe these workflows automatically.": "Beskriv, hvad du vil have i chatten \u2013 planl\u00e6ggeren unders\u00f8ger disse workflows automatisk.",
  "Description": "Beskrivelse",
  "description (optional)": "beskrivelse (valgfrit)",
  "Detected": "Opdaget",
  "Device connected": "Enhed tilsluttet",
  "Diagnosis failed": "Diagnose mislykkedes",
  "didn't finish connecting. Please click Connect again and complete the popup (make sure it isn't blocked).": "blev ikke f\u00e6rdig med at oprette forbindelse. Klik venligst p\u00e5 Opret forbindelse igen og fuldf\u00f8r pop op-vinduet (s\u00f8rg for, at det ikke er blokeret).",
  "Direction": "Retning",
  "Discard draft": "Kass\u00e9r kladde",
  "Discard your unsaved edits and reload the latest saved version": "Kass\u00e9r dine ikke-gemte redigeringer og genindl\u00e6s den senest gemte version",
  "Disconnect": "Afbryd forbindelsen",
  "Disconnect account?": "Vil du afbryde forbindelsen til kontoen?",
  "Disconnect this account": "Afbryd denne konto",
  "Dismiss": "Afvis",
  "Distance": "Afstand",
  "Docs": "Dokumenter",
  "DOCS": "DOCS",
  "Doctor": "L\u00e6ge",
  "Dokumentation": "Dokumentation",
  "Don\u2019t check this on a node that other Browser Action nodes continue from \u2014 they\u2019d lose the tab.": "Kontroller ikke dette p\u00e5 en knude, som andre browserhandlingsknuder forts\u00e6tter fra - de ville miste fanen.",
  "Don't Wait": "Vent ikke",
  "Done": "F\u00e6rdig",
  "Done!": "F\u00e6rdig!",
  "Down": "Ned",
  "Download this workflow as a Node.js file": "Download denne workflow som en knude.js-fil",
  "Draft": "Udkast",
  "Drag a rectangle over the part of the preview you want to attach.": "Tr\u00e6k et rektangel over den del af forh\u00e5ndsvisningen, du vil vedh\u00e6fte.",
  "Drag nodes from the sidebar to get started, or let AI design and build your workflow automatically.": "Tr\u00e6k knuder fra sidebj\u00e6lken for at komme i gang, eller lad AI designe og bygge din workflow automatisk.",
  "Drag to reorder step": "Tr\u00e6k for at omarrangere trin",
  "Drag to shape curve (double-click to remove)": "Tr\u00e6k for at forme kurven (dobbeltklik for at fjerne)",
  "Drag to transfer connector": "Tr\u00e6k for at overf\u00f8re stik",
  "Drive a real Chrome tab to reach a goal": "K\u00f8r en \u00e6gte Chrome-fane for at n\u00e5 et m\u00e5l",
  "Du n\u00e6rmer dig din gr\u00e6nse. Overvej at opgradere din plan.": "Du n\u00e6rmer dig din gr\u00e6nse. Overvej at opgradere din plan.",
  "Duplicate node": "Dublet knude"
};
